import React from "react"
import ParticipantSidebar from "../../../components/sidebars/ParticipantSidebar"

export default function ParticipantReferralLayout(Props) {
  return (
    <div className="layout-with-sidebar">
      <div className="sidebar">
        <ParticipantSidebar />
      </div>
      <div className="main-content">{Props.children}</div>
    </div>
  )
}
